import { useMutation, useQuery } from '@apollo/react-hooks';
import { gql } from 'apollo-boost';
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';
import { useState } from 'react';

const CREATE_USER_QUERY = gql`
  mutation insertOneClient($client: ClientInsertInput!) {
    insertOneClient(data: $client) {
      _id
      email
      mobilePhone
    }
  }
`;

export function useCreateClient() {
  const [createClient, { loading, error, data }] =
    useMutation(CREATE_USER_QUERY);

  return {
    createClient,
    loading,
    error,
    clientPhone: data ? data.createClient : undefined,
  };
}

const UPDATE_USER_QUERY = gql`
  mutation updateOneClient($id: ObjectId!, $client: ClientUpdateInput!) {
    updateOneClient(query: { _id: $id }, set: $client) {
      _id
      email
    }
  }
`;

export function useUpdateClient() {
  const [updateClient, { loading, error, data }] =
    useMutation(UPDATE_USER_QUERY);
  return {
    updateClient,
    loading,
    error,
    client: data ? data.updateOneClient : undefined,
  };
}

const GET_CUSTOMER_QUERY = gql`
  query clients($id: ObjectId!) {
    clients(query: { tenant: { _id: $id } }) {
      _id
      email
      firstName
      middleName
      lastName
      mobilePhone
      address1
      address2
      city
      state
      zipcode
      propertyAddress1
      propertyAddress2
      propertyCity
      propertyState
      propertyZipcode
      active
      updatedAt_utc
      createdAt_utc
      ssn
      tenant {
        _id
        name
        tenantGroup {
          _id
          groupName
          logoURL
          groupTagline
          bannerColor
        }
      }
    }
  }
`;

export function useClient(emailID) {
  const email = isNil(emailID) || isEmpty(emailID) ? null : emailID;
  const { loading, error, data, refetch } = useQuery(GET_CUSTOMER_QUERY, {
    variables: { where: { email: email } },
  });
  return {
    loadingSearch: loading,
    error,
    refetch,
    client: data ? data.allClients[0] : undefined,
  };
}

const GET_CUSTOMER_BY_PHONE = gql`
  query client($mobilePhone: String!) {
    client(query: { mobilePhone: $mobilePhone }) {
      _id
      email
      firstName
      middleName
      lastName
      mobilePhone
      address1
      address2
      city
      state
      zipcode
      propertyAddress1
      propertyAddress2
      propertyCity
      propertyState
      propertyZipcode
      active
      updatedAt_utc
      createdAt_utc
      ssn
      tenant {
        _id
        name
        tenantGroup {
          _id
          groupName
          logoURL
          groupTagline
          bannerColor
        }
      }
    }
  }
`;

export function useClientByPhone(mobilePhone) {
  const [mobileNumber, setMobileNumber] = useState(mobilePhone || null);
  const { loading, error, data, refetch } = useQuery(GET_CUSTOMER_BY_PHONE, {
    variables: { mobilePhone: mobileNumber },
    skip: !mobileNumber, // Skip the query if mobileNumber is null
  });

  const refetchWithNumber = (args) => {
    console.log(args);
    setMobileNumber(args?.mobilePhone);
    return refetch(args);
  };

  return {
    loadingSearch: loading,
    error,
    refetch: refetchWithNumber,
    client: data ? data.client : undefined,
  };
}
// const GET_ALL_CLIENT_DOCUMENT_QUERY = gql`
//   query allClientDocuments($where: ClientDocumentWhereInput!) {
//     allClientDocuments(where: $where) {
//       id
//       type
//       description
//       filePath
//       fileURL
//       status
//       active
//       transfer {
//         id
//       }
//     }
//   }
// `;

// export function useAllClientDocuments(clientID) {
//   const id = isNil(clientID) || isEmpty(clientID) ? null : clientID;
//   const { loading, error, data, refetch } = useQuery(
//     GET_ALL_CLIENT_DOCUMENT_QUERY,
//     {
//       variables: { where: { client: { id } } },
//     },
//   );
//   return {
//     loadingClientDoc: loading,
//     errorClientDoc: error,
//     refetchClientDoc: refetch,
//     clientDocuments: data ? data.allClientDocuments : [],
//   };
// }
